"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalPremiumTypeChangeModal = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var components_1 = require("@athena-portal/components");
var services_1 = require("@falcon/services");
var moment = require("moment/moment");
var reactstrap_1 = require("reactstrap");
var RenewalPremiumTypeChangeModal = /** @class */ (function (_super) {
    __extends(RenewalPremiumTypeChangeModal, _super);
    function RenewalPremiumTypeChangeModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            popupOpen: true
        };
        _this.closePopup = _this.closePopup.bind(_this);
        _this.cancelChanges = _this.cancelChanges.bind(_this);
        _this.updateRenewal = _this.updateRenewal.bind(_this);
        return _this;
    }
    RenewalPremiumTypeChangeModal.prototype.render = function () {
        var _a;
        var initialPaymentDate = this.props.interaction.renewalDetails.monthlyPayerInitialPaymentDate || this.props.interaction.renewalDetails.annualPayerInitialPaymentDate;
        return (React.createElement(components_1.Modal, { className: "my-2 info-modal", isOpen: this.state.popupOpen, toggle: this.closePopup },
            React.createElement(components_1.ModalHeader, { toggle: this.closePopup }, "You didn't save your changes"),
            React.createElement(components_1.ModalBody, null,
                React.createElement("p", null,
                    "Do you want to pay ",
                    ((_a = this.props.interaction.factors) === null || _a === void 0 ? void 0 : _a.premiumType) === services_1.AnnualPolicyPremiumTypeEnum.MONTHLY ? "monthly" : "annually",
                    " when your cover renews?"),
                React.createElement("p", null,
                    "No payment will be taken until ",
                    moment.utc(initialPaymentDate, moment.ISO_8601).format("DD MMM YYYY"),
                    "."),
                React.createElement("br", null),
                React.createElement("p", { className: "font-weight-bold" }, "Save changes and setup policy to renew?")),
            React.createElement(components_1.ModalFooter, null,
                React.createElement(reactstrap_1.Button, { className: "my-2 w-100 float-right", color: "btn btn-white", onClick: this.cancelChanges }, "No, cancel changes"),
                React.createElement(reactstrap_1.Button, { className: "my-2 px-4 w-100 float-right btn-link", color: "btn btn-primary btn-next-no-arrow", onClick: this.updateRenewal }, "Save & update renewal"))));
    };
    RenewalPremiumTypeChangeModal.prototype.closePopup = function () {
        this.setState({ popupOpen: false });
        this.props.onStateChange("uistate.temp.cancelChangesPressed", false);
    };
    RenewalPremiumTypeChangeModal.prototype.cancelChanges = function () {
        this.closePopup();
        window.location.href = "/dashboard/annualMotor/".concat(this.props.interaction.agreementNumber);
    };
    RenewalPremiumTypeChangeModal.prototype.updateRenewal = function () {
        this.closePopup();
        this.executeEvent("change");
    };
    return RenewalPremiumTypeChangeModal;
}(plugin_journey_1.WidgetBase));
exports.RenewalPremiumTypeChangeModal = RenewalPremiumTypeChangeModal;
//# sourceMappingURL=RenewalPremiumTypeChangeModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/renewal/RenewalPremiumTypeChangeModal.js
// module id = 3231
// module chunks = 0